module.exports = __webpack_public_path__ + "img/thumb-blog-5.dafc6f62.jpg";